import { AuthFrame } from '../components/auth-frame';
import { ResetPasswordCard, type ResetIntent } from '../components/reset-password-card';

export interface ResetPasswordPageProps {
  token: string | undefined;
  intent: ResetIntent | undefined;
}

export function ResetPasswordPage({ token, intent }: ResetPasswordPageProps) {
  return (
    <AuthFrame>
      <ResetPasswordCard token={token} intent={intent} />
    </AuthFrame>
  );
}
